import $ from 'jquery';
import 'multiple-select/dist/multiple-select';
import 'bootstrap/js/dist/modal';

$(document).ready(function() {
  var selectFuel = $('#select_fuels');
  var selectProperty = $('#select_properties');

  $(selectFuel).multipleSelect({
    onClick: function () {
      filterFuel();
      handleParams();
    },
    onCheckAll: function() {
      $('li.fuel-check').addClass('selected');
      filterFuel();
      handleParams();
    },
    onUncheckAll: function() {
      $('li.fuel-check').removeClass('selected');
      filterFuel();
      handleParams();
    },
    placeholder: "All selected",
    maxHeight: 239,
  });

  $(selectProperty).multipleSelect({
    onClick: function () {
      filterProperty();
      handleParams();
    },
    onCheckAll: function() {
      $('li.property-check').addClass('selected');
      filterProperty();
      handleParams();
    },
    onUncheckAll: function() {
      $('li.property-check').removeClass('selected');
      filterProperty();
      handleParams();
    },
    placeholder: "All selected",
    maxHeight: 239,
  });

  buildTable();

  function filterProperty() {
    var propertyRow = $('.property-row');
    var checkboxes = $('.property-check.selected label input[type=checkbox]');
    if ($(checkboxes).length) {
      $(propertyRow).hide();
      $(checkboxes).each(function() {
        var checkValue = $(this).val();
        propertyRow.each(function() {
          if ($(this).data('property').toString() === checkValue) {
            $(this).show();
          }
        });
      });
    } else {
      $('.property-row').show();
    }
  }

  function filterFuel() {
    var fuelColumn = $('.fuel-column');
    var checkboxes = $('.fuel-check.selected label input[type=checkbox]');
    if ($(checkboxes).length) {
      $(fuelColumn).hide();
      $(checkboxes).each(function() {
        var checkValue = $(this).val();
        fuelColumn.each(function() {
          if ($(this).data('fuel').toString() === checkValue) {
            $(this).show();
          }
        });
      });
    } else {
      $('.fuel-column').show();
    }
  }

  function handleParams() {
    var url = new URL(location);

    var fuels = [];
    $('li.fuel-check.selected input').each(function() {
      fuels.push($(this).attr("value"));
    });

    if (fuels.length > 0) {
      url.searchParams.set('fuels', fuels);
    } else {
      url.searchParams.delete('fuels');
    }

    var properties = [];
    $('li.property-check.selected input').each(function() {
      properties.push($(this).attr("value"));
    });

    if (properties.length > 0) {
      url.searchParams.set('properties', properties);
    } else {
      url.searchParams.delete('properties');
    }

    if (url.search.length > 0) {
      window.history.replaceState('', document.title, decodeURIComponent(url.search));
    } else {
      window.history.replaceState('', document.title, window.location.pathname);
    }

    $('#share-link').val(decodeURIComponent(url));
  }

  function buildTable() {
    filterFuel();
    filterProperty();
    handleParams();
    var tableHead = $('.table-header');
    var rows = $("tr").find('td:not(:eq(0))');
    $(tableHead).show();
    $(rows).removeClass('hide-cell');
  }

  function addSourceLinksToCell(cell) {
    var linkText = cell.innerText.match(/\([a-n]\)/g);
    if (linkText) {
      linkText.forEach(function(match) {
        var link = "(<a href='properties_notes.html#" + match[1] + "'>" + match[1] + "</a>)";
        cell.innerHTML = cell.innerHTML.replace(match, link);
      })
    }
  }

  function addNoteLinksToCell(cell) {
    var linkText = cell.innerText.match(/\[[1-7]\]/g);
    if (linkText) {
      linkText.forEach(function(match) {
        var link = "[<a href='properties_notes.html#" + match[1] + "'>" + match[1] + "</a>]";
        cell.innerHTML = cell.innerHTML.replace(match, link);
      })
    }
  }

  function addAllLinksToTable() {
    $('#result-list td, #result-list th').each(function() {
      addSourceLinksToCell(this);
      addNoteLinksToCell(this);
    })
  }

  addAllLinksToTable();

  function addModalToPropertyColumn() {
    var exp = /(feedstocks|Gasoline or Diesel Gallon Equivalent|lower heating value|higher heating value|cetane number|pump octane number|Flash Point|Autoignition Temperature)/
    $('td.property-column.property-row, th.property-column.property-row').each(function() {
      var linkText = this.innerText.match(exp);
      if (linkText) {
        const capitalized = capitalizeEachWord(linkText[0])
        var link = "<a href='/glossary#" + capitalized + "' class='glossary'>" + linkText[0] + "</a>";
        this.innerHTML = this.innerHTML.replace(linkText[0], link);
      }
    })
  }

  function capitalizeEachWord(string) {
    return string.split(" ").map(function(word) {
      if (word === "or" || word === "and") {
        return word;
      } else {
        return word[0].toUpperCase() + word.slice(1);
      }
    }).join("")
  }

  addModalToPropertyColumn();
});
